/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:903efa04-3e7f-440a-ba31-93ee1abcad41",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_jyvtxyCgj",
    "aws_user_pools_web_client_id": "62642cf9ui16pfq3uomlbh04a5",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "tdbDynamoBets-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "tdbDynamoCategory-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "tdbDynamoMember-dev",
            "region": "us-east-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "TwoDollarBetApi",
            "endpoint": "https://cpfh5fqkn9.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
